"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagCard = void 0;
const core_api_1 = require("@ikegps/core-api");
const autocomplete_menu_1 = require("../../components/autocomplete.menu/autocomplete.menu");
const image_button_1 = require("../../components/button/image.button");
const icons_1 = require("../../components/icon/icons");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const dom_1 = require("../../dom");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const page_state_1 = require("../../state/page.state");
const store_1 = require("../../store");
const photomeasure_button_1 = require("../photomeasure.button/photomeasure.button");
const tag_card_checkbox_1 = require("../tag.card.checkbox/tag.card.checkbox");
const bounding_string_1 = require("../tag.map/bounding.string");
const tag_name_input_1 = require("../tag.name.input/tag.name.input");
const tag_name_input_ctrl_1 = require("../tag.name.input/tag.name.input.ctrl");
const topological_editor_button_1 = require("../topological.editor.button/topological.editor.button");
const tag_card_style_1 = require("./tag.card.style");
(0, theme_1.addStyles)(tag_card_style_1.Style);
class TagCard {
    constructor(state, tag) {
        this.autoCompleteMenu = null;
        this.state = state;
        this.tag = tag;
        this.ctrl = new tag_name_input_ctrl_1.TagNameInputController(this.state, tag);
        this.autoCompleteMenu = new autocomplete_menu_1.AutoCompleteMenu({
            inputState: this.ctrl.getInputState(),
            options: () => this.ctrl.autoCompleteOptions,
            onselect: (option) => this.ctrl.updateEdit(option.value)
        });
    }
    view() {
        const isHovered = page_state_1.CurrentState.hoverId === this.tag.objectId;
        const className = `${tag_card_style_1.CSS.container} ${isHovered ? tag_card_style_1.CSS.isHovered : ''}`;
        const summary = store_1.AppStore.TagSummary.get(this.tag.objectId);
        const hasSummary = summary != null;
        const editing = this.state.edit.isEditingTag(this.tag.objectId);
        const renaming = this.state.edit.isRenamingTag(this.tag.objectId);
        const showEditButtons = !this.state.edit.isEditingTag() && !this.state.edit.isRenamingTag() && !page_state_1.CurrentState.CollectionEdit.isDirty;
        const toolbar = this.makeToolbar();
        const collectionsSelected = page_state_1.CurrentState.Tag.collectionsSelectedSize(this.tag.objectId);
        const selectedState = {
            isSelected: () => collectionsSelected === summary.revisions.length,
            setSelected: selected => page_state_1.CurrentState.Tag.selectTag(this.tag.objectId, selected),
            isIndeterminate: () => collectionsSelected > 0 && collectionsSelected < summary.revisions.length
        };
        const children = [
            hasSummary ? tag_card_checkbox_1.TagCardCheckbox.view(this.state, selectedState, this.tag, summary) : null,
            editing ? tag_name_input_1.TagNameInput.view(this.ctrl, this.autoCompleteMenu) : tag_name_input_1.TagNameReadonlyInput.view(this.ctrl),
            renaming ? spinner_1.Spinner.view() : null,
            showEditButtons ? toolbar : null
        ];
        return (0, mithril_1.m)('div', {
            className,
            key: this.tag.objectId,
            [dom_1.DRAGON_ID]: this.tag.objectId,
            [dom_1.DRAGON_TYPE]: dom_1.DragonDomTypes.TAG
        }, children);
    }
    makeToolbar() {
        var _a;
        const canEdit = services_1.Services.Token.has(core_api_1.IkeToken.TAG_JOB_UPDATE);
        const tagCenterObj = (_a = store_1.AppStore.TagSummary.get(this.tag.objectId)) === null || _a === void 0 ? void 0 : _a.center;
        if (!tagCenterObj) {
            return null;
        }
        const tagCenterString = bounding_string_1.BoundingString.toString(tagCenterObj, 15);
        var children = [
            (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_MAP_MODE) &&
                !services_1.Services.UserProfile.isReadOnly(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId))) && (topological_editor_button_1.TopologicalEditorButton.view(this.tag.objectId, tagCenterString)),
            photomeasure_button_1.PhotomeasureButton.view(this.tag.objectId),
            canEdit && (image_button_1.ImageButton.view(icons_1.MaterialIcon.EDIT, {
                title: i18n_1.T.LINK_EDIT_TAG,
                className: tag_card_style_1.CSS.renamejob,
                onclick: () => this.state.edit.editTag(this.tag.objectId, this.tag.name)
            }))
        ];
        return (0, mithril_1.m)('div', { className: tag_card_style_1.CSS.toolbar }, children);
    }
}
exports.TagCard = TagCard;
//# sourceMappingURL=tag.card.js.map